

export class FilterFields {
        static getFields(key, input, placeholder, required) {
                return ({
                        key,
                        input,
                        placeholder,
                        valids: required ? [
                                {
                                        valid: 'required',
                                        error: placeholder + ' is required'
                                }
                        ] : []
                });
        }
}
export const MODEL_FIELDS = {
        COPY_GROUP_FUNCTION_FIELDS: [
                FilterFields.getFields('todate', 'date', 'To Date', true)
        ],
        MERGE_ACCOUNT_FIELDS: [
                FilterFields.getFields('toaccount', 'dropdown', 'Account', true)
        ],
        FILTER_USING_DATES: [
                FilterFields.getFields('fromdate', 'date', 'From Date', true),
                FilterFields.getFields('todate', 'date', 'To Date', true)
        ],
        FILTER_USING_DATES_AND_PROPERTY: [
                FilterFields.getFields('fromdate', 'date', 'From Date', true),
                FilterFields.getFields('todate', 'date', 'To Date', true),
                FilterFields.getFields('property', 'dropdown', 'Property', true)
        ],
        FILTER_USING_DATES_AND_USER: [
                FilterFields.getFields('fromdate', 'date', 'From Date', true),
                FilterFields.getFields('todate', 'date', 'To Date', true),
                FilterFields.getFields('touser', 'dropdown', 'SalesPerson', true)
        ],
        FILTER_USING_DATES_AND_USER_AND_PROPERTY: [
                FilterFields.getFields('fromdate', 'date', 'From Date', true),
                FilterFields.getFields('todate', 'date', 'To Date', true),
                FilterFields.getFields('touser', 'dropdown', 'SalesPerson', true),
                FilterFields.getFields('property', 'dropdown', 'Property', true)
        ],
        FILTER_USING_USER: [
                FilterFields.getFields('touser', 'dropdown', 'To SalesPerson', true)
        ],
        FILTER_USING_USER_AND_PROPERTY: [
                FilterFields.getFields('touser', 'dropdown', 'To SalesPerson', true),
                FilterFields.getFields('property', 'dropdown', 'Property', true)
        ],
        FILTER_USING_USER_AND_MARKET_SEGMENT: [
                FilterFields.getFields('touser', 'dropdown', 'To SalesPerson', false),
                FilterFields.getFields('toMarketSegment', 'dropdown', 'Market Segment', false)
        ],
        FILTER_USING_CONTACT: [
                FilterFields.getFields('touser', 'dropdown', 'To Contact', true)
        ],
        FILTER_USING_GROUP_NAME: [
                FilterFields.getFields('togroup', 'dropdown', 'Select Group Date', true)
        ],
        FILTER_USING_TEXT_FIELD: [
                FilterFields.getFields('totext', 'textArea', 'Enter Reason', true)
        ],
        FILTER_USING_DATE_AND_SALESPERSON: [
                FilterFields.getFields('fromdate', 'date', 'From Date', true),
                FilterFields.getFields('touser', 'dropdown', 'To SalesPerson', true),
        ],
        FILTER_USING_TEXT: [
                FilterFields.getFields('totext1', 'text', 'Enter length', true),
                FilterFields.getFields('totext2', 'text', 'Enter width', true),
                FilterFields.getFields('totext', 'text', 'Enter Name', true),
                FilterFields.getFields('totext3', 'text', 'Enter capacity', true)
        ]
};



// WEBPACK FOOTER //
// ./src/app/shared/search-filter-fields.ts